<div style="padding-right: 16px" (mouseleave)="hideSubMenu()">
  <mat-card class="my-fav">
    <div
      class="border-bottom pl-5px menu"
      style="min-height: 20px"
      (click)="onFavSelect('Approval Pending')"
      [ngClass]="{ 'menu-active': selectedFav === 'Approval Pending' }"
      *ngIf="this.user_role === 'curator' || this.user_role === 'admin'"
    >
      <img
        src="/assets/icons/Exclamation.svg"
        alt="icon1"
        width="16"
        height="16"
      /><span class="fix-menu" > Approval Pending</span>
      <span
        style="
          border-radius: 10px;
          background-color: #5e5e72;
          height: 18px;
          width: auto;
          text-align: center;
        "
      >
        <label style="color: aliceblue; padding: 10px">{{
          approvalPendingCount
        }}</label></span
      >
    </div>
    <div
      class="border-bottom pl-5px menu"
      style="min-height: 20px"
      (click)="onFavSelect('My Prompts')"
      [ngClass]="{ 'menu-active': selectedFav === 'My Prompts' }"
      *ngIf="this.user_role === 'creator' || this.user_role === 'curator' || this.user_role === 'admin'"
    >
      <img
        src="/assets/icons/person_edit.svg"
        alt="icon1"
        width="16"
        height="16"
      /><span class="fix-menu" > My Prompts</span>
      <div class="category-count">{{ myPromptsCount }}</div>
    </div>
    <div
      class="border-bottom menu pl-5px"
      style="min-height: 20px"
      (click)="onFavSelect('My Favourites')"
      [ngClass]="{ 'menu-active': selectedFav === 'My Favourites' }"
    >
      <img
        src="/assets/icons/Favorite.svg"
        alt="icon1"
        width="16"
        height="16"
      />
      <span class="fix-menu" > My Favourites</span>
      <div class="category-count">{{ myFavCount }}</div>
    </div>
    <div
      (click)="onFavSelect('All Categories')"
      style="min-height: 20px"
      class="menu pl-5px"
      [ngClass]="{ 'menu-active': selectedFav === 'All Categories' }"
    >
      <img
        src="/assets/icons/category.svg"
        alt="icon2"
        width="16"
        height="16"
      />
      <span class="fix-menu" > All Categories</span>
      <div class="category-count">{{ totalcount }}</div>
    </div>
    <div *ngFor="let i of allcategory" class="tooltip-container" (mouseenter)="showSubMenu(i, $event)">
      <div
        class="menu"
        (click)="onFavSelect(i)"
        [ngClass]="{
          'menu-active': subcatValue === i.name || parentcateName == i.name
        }"
      >
      <div class="truncate">
        <div class="sub-category-name fix-menu truncate-text" [title]="i.name" >{{ i.name }}</div>
      </div>
        <div class="category-count">{{ i.prompt_count }}</div>
        <img  *ngIf="i.subcategories && i.subcategories.length > 0" src="/assets/icons/arrow_forward_ios.svg" alt="arrow_forward_ios"/>
      </div>
    </div>

  </mat-card>

  <!-- Tooltip container outside of .my-fav -->
  <div *ngIf="activeSubMenu?.subcategories?.length > 0" class="tooltip-content" [ngStyle]="tooltipStyles">
    <div class="sub-category-list">
      <div
        *ngFor="let subCategory of activeSubMenu.subcategories"
        (click)="onFavSelect(subCategory, $event, activeSubMenu.name)"
        class="sub-category"
        [ngClass]="{'menu-active': selectedFav === subCategory.name}"
      >
        <div class="sub-category-name">{{ subCategory.name }}</div>
        <div class="category-count">{{ subCategory.prompt_count }}</div>
      </div>
    </div>
  </div>
</div>